export const GET_GATICKET_LOADING = 'REDUX_SAGA_GET_GATICKET_LOADING';
export const GATICKET_DATA_SUCCESS = 'REDUX_SAGA_GATICKET_DATA_SUCCESS';
export const GATICKETDISPLAYAREA_DATA_SUCCESS = 'REDUX_SAGA_GATICKETDISPLAYAREA_DATA_SUCCESS';
export const GATICKET_DATA_ERROR = 'REDUX_SAGA_GATICKET_DATA_ERROR';
export const GATICKET_UPDATE_QUANTITY = 'REDUX_SAGA_GATICKET_UPDATE_QUANTITY';

export const actionGetGATickets = (dispatch, DisplayArea, GACouponCode) => {
    dispatch({
        type: GET_GATICKET_LOADING,
        payload: { DisplayArea, GACouponCode }
    })
};

export const actionUpdateQuantityToProduct = (dispatch, ProductID, Quantity) => {
    dispatch({
        type: GATICKET_UPDATE_QUANTITY,
        payload: { ProductID, Quantity }
    })
}